import {UserRole} from "@/shared/enums/UserRolesEnums";
import AnalyticsTerminatedPrivateCoaching from "@/views/App/Analytics/TerminatedCoaching/PrivateCoaching/List.vue";


const routesAnalyticsTerminatedCoaching = [
    {
        path: "private-coaching",
        name: "analyticsTerminatedPrivateCoaching",
        component: AnalyticsTerminatedPrivateCoaching,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.PRACTICE_MANAGER,
                UserRole.ASSISTANT_VQ,
                UserRole.HEAD_OF_AMDL,
                UserRole.SITE_SUPPORT,
            ]
        },
    }
]

export default routesAnalyticsTerminatedCoaching;